/** @type {Glob} */
export default window.glob;
